export enum ReferenceLookupMultiMatchOption {
  UseFirstMatch = 0,
  Continue = 1
}